import React from "react";
import { useLocation } from "react-router-dom";
import { Button, Table, Col, Row, } from "react-bootstrap";
import * as XLSX from "xlsx";
import PageLayout from "../../../layouts/PageLayout";
import { Link } from "react-router-dom";

export default function FilteredFamilies() {

  const location = useLocation();
  const families = location.state?.data || [];
  console.log("Received filtered families data:", families);
  // ⭐ Download as Excel
  const downloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(families);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Families");
    XLSX.writeFile(workbook, "Filtered_Families.xlsx");
  };

  return (


    <PageLayout>
      <Row>
        <Col xl={12}>
          <div className="mc-card">
            <div className="mc-breadcrumb">
              <h3 className="mc-breadcrumb-title">Filters</h3>
              <ul className="mc-breadcrumb-list">
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">Home</Link>
                </li>
                <li className="mc-breadcrumb-item">
                  <Link to="#" className="mc-breadcrumb-link">Filtered Families</Link>
                </li>
                <li className="mc-breadcrumb-item">Filters</li>
              </ul>
            </div>
          </div>
        </Col>

        <div className="mc-card" style={{ padding: "20px" }}>
          <h3>Filtered Families</h3>

          <Button variant="success" onClick={downloadExcel} style={{ marginBottom: "20px" }}>
            Download Excel
          </Button>

    
    <div className="table-responsive">

          <Table bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Family Request ID</th>
                <th>FSF ID</th>
                <th>Name</th>
                <th>CNIC</th>
                <th>Mobile</th>

                {/* Amounts */}
                <th>Loan Amount</th>
                <th>Transportation</th>
                <th>Housing</th>
                <th>Meal</th>
                <th>Affidavit</th>
                <th>Utility</th>
                <th>Medical</th>
                <th>Food Ration</th>
                <th>Other</th>
                <th>Khatta Amount</th>
                <th>Estimated Business Cost</th>

                <th>Relocation Total</th>

                {/* Business */}
                <th>Business Type</th>
                <th>Equipment Cost</th>
              </tr>
            </thead>

            <tbody>
              {families.length === 0 ? (
                <tr>
                  <td colSpan={20}><center>No data found...</center></td>
                </tr>
              ) : (
                families.map((f, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td>{f.rfq_id}</td>
                    <td>{f.fsf_id}</td>
                    <td>{f.name}</td>
                    <td>{f.cnic}</td>
                    <td>{f.mobile}</td>

                    <td>{f.loan_amount}</td>
                    <td>{f.transportation}</td>
                    <td>{f.housing}</td>
                    <td>{f.meal_amount}</td>
                    <td>{f.affidavit_amount}</td>
                    <td>{f.utility_amount}</td>
                    <td>{f.medical_amount}</td>
                    <td>{f.food_ration}</td>
                    <td>{f.other}</td>
                    <td>{f.khatta_amount}</td>
                    <td>{f.estimated_business_cost}</td>

                    <td><strong>{f.relocation_total}</strong></td>

                    <td>{f.business_type_name}</td>
                    <td>{f.equipment_cost}</td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
</div>

        </div>
      </Row>
    </PageLayout>
  );
}
